import { Box, Button, FormControl, FormControlLabel, FormGroup, Grid, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Paper, Switch, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../../app/store";
import configUrls from "../../../config/configUrls";
import errorFormat from "../../../utils/errorFormat";


import { ProcessoEnviarDTO } from "../../../types/processo/ProcessoSetoresDTO";

import { GridDeleteIcon } from "@mui/x-data-grid";
import { ISsetor, Setor } from "../../../types/setor/Setor";
import TxtSetor from "../../autoComplete/TxtSetor";
import { useEnviarProcessoMutation } from "./processoEnviarApiSlice";


export const ProcessoEnviarForm = () => {

    const [setores, setSetores] = useState<Setor[]>([]);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const navigate = useNavigate();

    const [setorSelecionadoTemp, setSetorSelecionadoTemp] = useState<Setor>(ISsetor);
    const [createEnvio, status] = useEnviarProcessoMutation();


    // Hook para seleção do processo
    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    useEffect(() => {
        if (!processoSelecionado) {
            alert("Nenhum processo foi previamente selecionado");
            navigate(configUrls.PROCESSO_LIST_RT); // Usando useNavigate para navegação
        }
    }, [processoSelecionado, navigate]);

    const [isManterUnidadeAtual, setIsManterUnidadeAtual] = useState(true);
    const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsManterUnidadeAtual(e.target.checked);
    };


    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();



        if (!setores || setores.length === 0) {
            enqueueSnackbar("Selecione pelo menos um setor!", { variant: "error" });
            return;
        }
        const parms: ProcessoEnviarDTO = {
            id: "",
            setoresIds: setores.map((it) => it.id), // Mapear corre
            processoId: processoSelecionado ? processoSelecionado.id : "",
            manterUnidadeAtual: isManterUnidadeAtual,
        }
        await createEnvio(parms);
    }

    useEffect(() => {

        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(-1);
            // setGrupo(ISgrupo);          

        }
    }, [status]);





    const handletxtSetorChange = (setor: Setor) => {
        setSetorSelecionadoTemp(setor)
    };

    const handleAdicionarSetor = () => {
        if (setorSelecionadoTemp && setorSelecionadoTemp.id) {

            if (setores && setores.some((setor) => setor.id === setorSelecionadoTemp.id)) {
                enqueueSnackbar("Este setor já está adicionado!", { variant: "error" });
                return;
            }
            setSetores((prev) => [...prev, setorSelecionadoTemp]);

            setSetorSelecionadoTemp(ISsetor);
        }
    }

    const handleExcluirSetor = (setor: Setor) => {
        if (setores) {

            //crio um novo array de setor sem o setor a ser excluito
            const novosSetores = setores.filter((it) => it.id !== setor.id);

            setSetores(novosSetores);
        }
    }








    return (



        <>


            <Paper>

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Envio do processo: {processoSelecionado?.numeroProcesso}

                </Typography>
                <Box mt={2} p={2}>

                    <form onSubmit={handleSubmit} method='POST'>

                        <Grid container spacing={3}>
                            <Grid item xs={12} mt={3}>
                                <Box display="flex" >
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Switch

                                                    name="ativo"
                                                    color="secondary"
                                                    checked={isManterUnidadeAtual}
                                                    onChange={handleToggle}
                                                    inputProps={{ "aria-label": "controlled" }}
                                                />
                                            }
                                            label={"Manter processo na unidade atual. "}
                                        />

                                    </FormGroup>
                                </Box>
                            </Grid>


                            <Grid item xs={12}>
                                <Box display="flex" justifyContent="space-between" gap={2}>
                                    <FormControl fullWidth>
                                        <TxtSetor
                                            value={setorSelecionadoTemp}
                                            handleSearchChange={(setor) => {
                                                handletxtSetorChange(setor);
                                            }}
                                        />
                                    </FormControl>
                                    <FormControl>
                                        <Button
                                            onClick={handleAdicionarSetor}
                                            variant="contained"
                                            color="primary"
                                            // disabled={isdisabled}
                                            sx={{ minWidth: 'auto', width: 'auto', alignSelf: 'center' }} // Ajusta o tamanho e alinha
                                        >
                                            Adicionar
                                        </Button>
                                    </FormControl>
                                </Box>




                                {setores && setores.length > 0 && (

                                    <FormControl fullWidth>
                                        <List dense sx={{ border: '2px solid #1976d2', borderRadius: '8px', backgroundColor: "#d3d3d3" }}>
                                            {setores.map((it) => {

                                                let descricao: string = "";

                                                if (it.nome) {
                                                    descricao = it.nome;
                                                }

                                                if (it.secretaria?.orgao?.abreviatura) {
                                                    descricao += " - " + it.secretaria.orgao.abreviatura;
                                                }

                                                if (it.secretaria?.abreviatura) {
                                                    descricao += " - " + it.secretaria.abreviatura;
                                                }




                                                return (


                                                    <ListItem key={it.id}>
                                                        <ListItemText primary={descricao} />
                                                        <ListItemSecondaryAction>
                                                            <IconButton
                                                                edge="end" aria-label="delete" onClick={() => handleExcluirSetor(it)}>
                                                                <GridDeleteIcon color="secondary" />
                                                            </IconButton>
                                                        </ListItemSecondaryAction>
                                                    </ListItem>
                                                )
                                            })}
                                        </List>
                                    </FormControl>
                                )}

                            </Grid>


                            <Grid item xs={12}>
                                <Box display="flex" gap={2}>

                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="secondary"
                                    >
                                        Gravar
                                    </Button>

                                    <Button
                                        variant="contained"
                                        onClick={() => navigate(-1)}
                                    >
                                        Voltar
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>

                    </form>



                </Box>




            </Paper>










        </>







    );










};

/*
 <GrupoTurmaForm
                    grupoTurma={grupoTurmaState}
                    isdisabled={status.isLoading}
                    isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
*/